import type React from 'react'

interface BezierHandleDotProps {
  anchorX: number
  anchorY: number
  handleX: number
  handleY: number
  /** Dot radius (canvas units). */
  radius: number
  color: string
  /** Stroke width of the anchor→handle line (canvas units). */
  lineWidth: number
  /** Stroke width of the dot's outline (canvas units). */
  dotStrokeWidth: number
  /** Extra attributes for the dot, appended after its geometry/paint — e.g. `pointerEvents`, or
   *  the node-edit overlay's drag style + pointer handlers. */
  dotProps?: React.SVGProps<SVGCircleElement>
}

/** One Bézier control handle: a line from its anchor to the handle position, capped by a white
 *  dot. Shared by the pen-tool (drawing) and node-edit overlays. */
export function BezierHandleDot({
  anchorX,
  anchorY,
  handleX,
  handleY,
  radius,
  color,
  lineWidth,
  dotStrokeWidth,
  dotProps,
}: BezierHandleDotProps) {
  return (
    <>
      <line
        x1={anchorX}
        y1={anchorY}
        x2={handleX}
        y2={handleY}
        stroke={color}
        strokeWidth={lineWidth}
        pointerEvents="none"
      />
      <circle
        cx={handleX}
        cy={handleY}
        r={radius}
        fill="white"
        stroke={color}
        strokeWidth={dotStrokeWidth}
        {...dotProps}
      />
    </>
  )
}
